import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@phishtool/ui';
import { StyledWrapper, StyledLink } from './styled';
const SectionLink = ({ to, iconName, children }) => (_jsx(StyledWrapper, Object.assign({ justify: "center" }, { children: _jsxs(StyledLink, Object.assign({ to: to }, { children: [_jsx(Icon, { name: iconName, fill: "oxfordBlue", height: 24 }), children] })) })));
export default SectionLink;
